"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDomEvent = exports.off = exports.on = exports.isBrowser = exports.canUseDOM = void 0;
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
exports.canUseDOM = canUseDOM;
exports.isBrowser = canUseDOM();
function on(obj, ...args) {
    if (obj && obj.addEventListener) {
        obj.addEventListener(...args);
    }
}
exports.on = on;
function off(obj, ...args) {
    if (obj && obj.removeEventListener) {
        obj.removeEventListener(...args);
    }
}
exports.off = off;
function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return () => {
        target.removeEventListener(eventName, handler, options);
    };
}
exports.addDomEvent = addDomEvent;
//# sourceMappingURL=dom.js.map